import React from 'react';
import { BellIcon, WrenchIcon, CheckIcon } from 'lucide-react';
const ARREARS = [{
  unit: 'Property A · Unit 4',
  tenant: 'John Doe',
  days: '3 days late',
  amount: 'UGX xxxx'
}, {
  unit: 'Property B · Unit 12',
  tenant: 'Jane Doe',
  days: '9 days late',
  amount: 'RWF xxxx'
}, {
  unit: 'Property C · Unit 2',
  tenant: 'John Doe',
  days: '21 days late',
  amount: 'UGX xxxx'
}];
const ACTIVITY = [{
  icon: BellIcon,
  text: '48 rent reminders sent across 3 properties',
  time: '06:00'
}, {
  icon: WrenchIcon,
  text: 'Leaking geyser · Property C, Unit 2 assigned to technician',
  time: '08:14'
}, {
  icon: CheckIcon,
  text: 'Payment matched · Property B, Unit 7 · Jane Doe cleared in full',
  time: '09:02'
}];
export function PropFlowPreview() {
  return <div className="border border-ink-200 bg-white shadow-sm" data-id="element-109" data-mp="3d6xhez7vziw2">
      <div className="flex items-center justify-between border-b border-ink-100 px-5 py-3" data-id="element-110" data-mp="3d9td0gw9hvhc">
        <span className="text-xs font-medium uppercase tracking-[0.16em] text-ink-500" data-id="element-111" data-mp="3i8mqi9bjtmhi">
          PropFlow · Portfolio
        </span>
        <span className="flex items-center gap-2 text-xs text-ink-500" data-id="element-112" data-mp="fgemeojcyb1y">
          <span className="block h-1.5 w-1.5 rounded-full bg-bronze-500" aria-hidden="true" data-id="element-113" data-mp="fi7tg4xvuxah" />
          Automations running
        </span>
      </div>

      <div className="grid gap-px bg-ink-100 sm:grid-cols-3" data-id="element-114" data-mp="ohl8dd4s0e2l">
        {[{
        value: '131',
        label: 'Units managed'
      }, {
        value: '92%',
        label: 'Collected this month'
      }, {
        value: '7',
        label: 'Open maintenance'
      }].map(item => <div key={item.label} className="bg-white px-5 py-5" data-id="element-115" data-mp="agiiepanujme">
            <span className="block text-2xl font-semibold tracking-tight text-ink-900" data-id="element-116" data-mp="ai3fomod0gny">
              {item.value}
            </span>
            <span className="mt-1 block text-xs text-ink-500" data-id="element-117" data-mp="3e5ltjqwkfs8r">{item.label}</span>
          </div>)}
      </div>

      <div className="border-t border-ink-100 px-5 py-5" data-id="element-118" data-mp="397kcfbipa2zx">
        <h3 className="text-xs font-medium uppercase tracking-[0.16em] text-ink-500" data-id="element-119" data-mp="394y439nzjjgn">
          Arrears needing attention
        </h3>
        <ul className="mt-3 divide-y divide-ink-100" data-id="element-120" data-mp="1i27f8wjpjkx9">
          {ARREARS.map(row => <li key={row.unit} className="flex items-center justify-between gap-4 py-2.5" data-id="element-121" data-mp="1msxgpyp0j3mo">
              <span className="min-w-0" data-id="element-122" data-mp="1qusu41k7x7gt">
                <span className="block truncate text-sm font-medium text-ink-900" data-id="element-123" data-mp="1qtr6yypxguiq">
                  {row.unit}
                </span>
                <span className="block truncate text-xs text-ink-500" data-id="element-124" data-mp="u74m4cdvevaz">
                  {row.tenant} · {row.days}
                </span>
              </span>
              <span className="shrink-0 text-sm font-medium text-bronze-700" data-id="element-125" data-mp="134opbqvan1o8">
                {row.amount}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="border-t border-ink-100 bg-ink-50 px-5 py-5" data-id="element-126" data-mp="2elepotd1cz9x">
        <h3 className="text-xs font-medium uppercase tracking-[0.16em] text-ink-500" data-id="element-127" data-mp="2jjpzj43bz9s5">
          Today, handled automatically
        </h3>
        <ul className="mt-3 space-y-3" data-id="element-128" data-mp="2tmli40342tue">
          {ACTIVITY.map(item => <li key={item.text} className="flex items-start gap-3" data-id="element-129" data-mp="2oo1vdxgp1e0z">
              <item.icon className="mt-0.5 h-4 w-4 shrink-0 text-bronze-600" aria-hidden="true" data-id="element-130" data-mp="2oqwf1mrvuutc" />
              <span className="text-sm leading-snug text-ink-700" data-id="element-131" data-mp="2fx1kt9sauosh">{item.text}</span>
              <span className="ml-auto shrink-0 text-xs text-ink-400" data-id="element-132" data-mp="2axon1tzw3xb4">{item.time}</span>
            </li>)}
        </ul>
      </div>
    </div>;
}